// extracted by mini-css-extract-plugin
export default {"dropdownItem":"chart_dropdownItem__s+mNR","mw__pane__1":"chart_mw__pane__1__GWiHu"};